// src/pages/Appli/AppliAdmin/VisitorCenter/data/visitorCenterData.js

import {
  FiBarChart2,
  FiClock,
  FiMap,
  FiMessageCircle,
  FiPhoneCall,
  FiUsers,
} from "react-icons/fi";

export const VISITOR_CENTER_TABS = [
  {
    key: "overview",
    label: "Vue d’ensemble",
    description:
      "Trafic, pages et conversions",
    icon: FiBarChart2,
  },
  {
    key: "live",
    label: "En direct",
    description:
      "Visiteurs actuellement présents",
    icon: FiMap,
  },
  {
    key: "sessions",
    label: "Historique",
    description:
      "Parcours et sessions enregistrées",
    icon: FiClock,
  },
  {
    key: "conversations",
    label: "Conversations",
    description:
      "Messages reçus depuis le site",
    icon: FiMessageCircle,
  },
  {
    key: "callbacks",
    label: "Demandes de rappel",
    description:
      "Contacts commerciaux à traiter",
    icon: FiPhoneCall,
  },
];

export const VISITOR_STATUS_CONFIG = {
  online: {
    label: "En ligne",

    className:
      "border-emerald-200 bg-emerald-50 text-emerald-700",

    dotClassName:
      "bg-emerald-500",
  },

  away: {
    label: "Absent",

    className:
      "border-amber-200 bg-amber-50 text-amber-700",

    dotClassName:
      "bg-amber-500",
  },

  offline: {
    label: "Hors ligne",

    className:
      "border-slate-200 bg-slate-100 text-slate-600",

    dotClassName:
      "bg-slate-400",
  },
};

export const CALLBACK_STATUS_OPTIONS = [
  {
    value: "",
    label: "Tous les statuts",
  },
  {
    value: "new",
    label: "Nouvelle",
  },
  {
    value: "contacted",
    label: "Contactée",
  },
  {
    value: "converted",
    label: "Convertie",
  },
  {
    value: "closed",
    label: "Clôturée",
  },
  {
    value: "cancelled",
    label: "Annulée",
  },
];

export const CONVERSATION_STATUS_OPTIONS = [
  {
    value: "",
    label:
      "Toutes les conversations",
  },
  {
    value: "open",
    label: "Ouverte",
  },
  {
    value: "waiting_admin",
    label:
      "Attend une réponse",
  },
  {
    value: "waiting_visitor",
    label:
      "Attend le visiteur",
  },
  {
    value: "closed",
    label: "Fermée",
  },
];

export const VISITOR_KPI_ICONS = {
  overview: FiBarChart2,
  live: FiUsers,
  sessions: FiClock,
  conversations:
    FiMessageCircle,
  callbacks: FiPhoneCall,
};